import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  header: {
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: theme.typography.fontWeightStrong,
  },
});

const ContentHeader = ({
  classes, title, subtitle, children,
}) => (
  <Grid container alignItems="center" justify="space-between" className={classes.header}>
    <div >
      <Typography align="left" variant="h6" color="textSecondary" className={classes.title}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography align="left" variant="body2" color="textSecondary">
          {subtitle}
        </Typography>
      ) : null}
    </div>
    {children}
  </Grid>
);

ContentHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

ContentHeader.defaultProps = {
  children: null,
  subtitle: null,
};

export default withStyles(styles)(ContentHeader);
